import { v4 as uuidv4 } from 'uuid'

export default async function getDeviceId() {
  try {
    let deviceId =
      localStorage.getItem('DEVICE_ID') ||
      sessionStorage.getItem('DEVICE_ID') ||
      (document.cookie.match(/DEVICE_ID=([^;]*)/) || [])[1]

    if (!deviceId) {
      deviceId = uuidv4()

      try {
        localStorage.setItem('DEVICE_ID', deviceId)
      } catch (e) {
        console.warn('Could not store device ID in localStorage:', e)
      }

      try {
        sessionStorage.setItem('DEVICE_ID', deviceId)
      } catch (e) {
        console.warn('Could not store device ID in sessionStorage:', e)
      }

      try {
        const expiryDate = new Date()
        expiryDate.setFullYear(expiryDate.getFullYear() + 1)
        document.cookie = `DEVICE_ID=${deviceId};expires=${expiryDate.toUTCString()};path=/;SameSite=Strict`
      } catch (e) {
        console.warn('Could not store device ID in cookie:', e)
      }
    } else {
      try {
        if (!localStorage.getItem('DEVICE_ID')) {
          localStorage.setItem('DEVICE_ID', deviceId)
        }
        if (!sessionStorage.getItem('DEVICE_ID')) {
          sessionStorage.setItem('DEVICE_ID', deviceId)
        }
        if (!document.cookie.includes('DEVICE_ID=')) {
          const expiryDate = new Date()
          expiryDate.setFullYear(expiryDate.getFullYear() + 1)
          document.cookie = `DEVICE_ID=${deviceId};expires=${expiryDate.toUTCString()};path=/;SameSite=Strict`
        }
      } catch (e) {
        console.warn('Error while syncing device ID across storages:', e)
      }
    }

    return deviceId
  } catch (error) {
    console.error('Failed to get or create device ID:', error)
    return null
  }
}
